import {
  IText,
  TEXT_SCHEMA,
  TextId,
  TextLanguageValueId,
} from './text/text.interfaces';
import { z } from 'zod/v4';
import { Brand } from '../branded-types';
import { LanguagePrefix } from './language.interfaces';

export type MessageType = 'success' | 'error' | 'info' | 'warning';

export enum EMessageType {
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
}

/*
TEMPLATE: <DOMAIN>-<ACTION>-<ID>

<DOMAIN>:
- CMS  -> CMS
- USR  -> User
- PAY  -> Payment
- AUTH -> Login
- JPS  -> Journey Planning
- TRF  -> Tariff
- TCK  -> Direct-Ticket
- SUB  -> Subscription
- CON  -> Contract
- INC  -> Incident
- FTR  -> Fellow Traveler

<ACTION>:
- FND  -> Find
- LOG  -> Logging
- SAV  -> Saving
- CHC  -> Check
- UPD  -> Update
- UPL  -> Upload
- CRT  -> Create
- DEL  -> Delete
- VAL  -> Validate
- EXP  -> Export
- TEST -> Test

*/
export enum EMessageCode {
  BLACKLIST_ERROR = 'BLI-VAL-01',
  //ADDRESS
  COUNTRIES_FETCH_ERROR = 'ADV-FND-02',
  CITIES_FETCH_ERROR = 'ADV-FND-04',
  CITIES_FETCH_REQUEST_ERROR = 'ADV-FND-05',
  STREETS_FETCH_ERROR = 'ADV-FND-07',
  STREETS_FETCH_REQUEST_ERROR = 'ADV-FND-08',
  HOUSE_NUMBERS_FETCH_ERROR = 'ADV-FND-10',
  HOUSE_NUMBERS_FETCH_REQUEST_ERROR = 'ADV-FND-11',
  ADDRESS_VALIDATION_ERROR = 'ADV-VLD-02',
  //CMS
  ENTITY_SAVED_SUCCESS = 'CMS-SAV-01',
  ENTITY_SAVED_BAD_REQUEST = 'CMS-SAV-02',
  ENTITY_SAVED_REPOSITORY_ERROR = 'CMS-SAV-03',
  ENTITY_FINDONE_REPOSITORY_ERROR = 'CMS-FND-02',
  ENTITY_FINDALL_SUCCESS = 'CMS-FND-03',
  ENTITY_FINDALL_REPOSITORY_ERROR = 'CMS-FND-04',
  ENTITY_FINDALL_EMPTY = 'CMS-FND-05',
  ENTITY_DOWNLOAD_ERROR = 'CMS-DWN-01',
  ENTITY_DELETE_SUCCESS = 'CMS-DEL-01',
  ENTITY_DELETE_REPOSITORY_ERROR = 'CMS-DEL-02',
  ENTITY_DELETE_FILE_ERROR = 'CMS-DEL-03',
  ENTITY_DELETE_BAD_REQUEST = 'CMS-DEL-04',
  ENTITY_UPLOAD_SUCCESS = 'CMS-UPL-01',
  ENTITY_UPLOAD_BAD_REQUEST = 'CMS-UPL-02',
  ENTITY_UPLOAD_REPOSITORY_ERROR = 'CMS-UPL-03',
  ENTITY_CREATE_VALIDATION_SUCCESS = 'CMS-VAL-01',
  ENTITY_CREATE_VALIDATION_ERROR = 'CMS-VAL-02',
  ENTITY_FILE_ERROR = 'CMS-FLE-01',
  ENTITY_EXPORT_SUCCESS = 'CMS-EXP-01',
  //LOGIN
  LOGIN_SUCCESS = 'AUTH-LOG-02',
  LOGIN_FAILED = 'AUTH-LOG-03',
  LOGOUT_SUCCESS = 'AUTH-LOG-04',
  LOGOUT_ERROR = 'AUTH-LOG-05',
  //USER
  USER_UPDATE_SUCCESS = 'USR-UPD-01',
  USER_UPDATE_FAILED = 'USR-UPD-02',
  USER_UPDATE_BAD_REQUEST = 'USR-UPD-03',
  USER_PASSWORD_RESET_SUCCESS = 'USR-UPD-04',
  USER_PASSWORD_RESET_FAILED = 'USR-UPD-05',
  USER_VALIDATION_SUCCESS = 'USR-ACT-01',
  USER_VALIDATION_ERROR = 'USR-ACT-02',
  USER_VALIDATION_NOT_ACTIVE = 'USR-ACT-03',
  //CONFIGURATION
  CONFIGURATION_FIND_ERROR = 'CON-FND-01',
  CONFIGURATION_PAYMENT_ERROR = 'CON-PAY-01',
  CONFIGURATION_PAYMENT_GUEST = 'CON-PAY-02',
  TICKETS_GUEST_PAYMENT_SUCCESS = 'CON-PAY-03',
  TICKETS_GUEST_PAYMENT_FAILED = 'CON-PAY-04',
  //DIRECT-TICKET
  TICKETS_FETCH_FAILED = 'TCK-FND-02',
  TICKETS_VALIDATION_SUCCESS = 'TCK-VLD-01',
  TICKETS_CREATE_ORDER_SUCCESS = 'TCK-SAV-01',
  TICKETS_CREATE_ORDER_FAILED = 'TCK-SAV-02',
  TICKETS_VALIDATION_FAILED = 'TCK-VLD-03',
  TICKETS_PAYMENT_FAILED = 'TCK-PAY-01',
  TICKETS_PAYMENT_SUCCESS = 'TCK-PAY-02',
  TICKETS_PAYMENT_STARTED = 'TCK-PAY-03',
  TICKET_REFUND_SUCCESS = 'TCK-REF-01',
  TICKET_REFUND_FAILED = 'TCK-REF-02',
  TICKET_CANNOT_BE_ADDED = 'TCK-ADD-01',
  TICKETS_CREATE_ENTITLEMENT_SUCCESS = 'TCK-ENT-01',
  TICKETS_CREATE_ENTITLEMENT_FAILED = 'TCK-ENT-02',
  TICKETS_CREATE_SECURITY_DETAIL_SUCCESS = 'TCK-SCD-01',
  TICKETS_CREATE_SECURITY_DETAIL_FAILED = 'TCK-SCD-02',
  TICKETS_CREATE_DOCUMENTS_SUCCESS = 'TCK-DOC-01',
  TICKETS_CREATE_DOCUMENTS_FAILED = 'TCK-DOC-02',
  TICKETS_SEND_EMAILS_SUCCESS = 'TCK-EMA-01',
  TICKETS_SEND_EMAILS_FAILED = 'TCK-EMA-02',
  TICKETS_CREATE_SALES_DATA_SUCCESS = 'TCK-SDA-01',
  TICKETS_CREATE_SALES_DATA_FAILED = 'TCK-SDA-02',
  //TARIF
  TARIFF_FETCH_FAILED = 'TRF-FND-02',
  TARIFF_FETCH_TIMEOUT = 'TRF-FND-03',
  //NOTIFY
  NOTIFY_MAIL_SEND_SUCCESS = 'NTF-MLS-01',
  NOTIFY_MAIL_SEND_ERROR = 'NTF-MLS-02',
  //Orders
  ORDER_FETCH_FAILED = 'ORD-FND-02',

  //TOKEN
  TOKEN_VALIDATION_SUCCESS = 'TKN-VLD-01',
  TOKEN_VALIDATION_FAILED = 'TKN-VLD-02',
  TOKEN_CREATE_AND_MAIL_SENT_SUCCESS = 'TKN-SAV-01',
  TOKEN_CREATE_AND_MAIL_SENT_FAILED = 'TKN-SAV-02',
  //PAYMENT
  PAYMENT_METHOD_DELETE_SUCCESS = 'PAY-MTH-01',
  //FELLOW TRAVELER
  FELLOW_TRAVELERS_FIND_ALL_SUCCESS = 'FTR-FND-01',
  FELLOW_TRAVELERS_FIND_ALL_FAILED = 'FTR-FND-02',
  FELLOW_TRAVELER_FIND_ONE_SUCCESS = 'FTR-FND-03',
  FELLOW_TRAVELER_FIND_ONE_FAILED = 'FTR-FND-04',
  FELLOW_TRAVELER_CREATE_SUCCESS = 'FTR-CRT-01',
  FELLOW_TRAVELER_CREATE_BAD_REQUEST = 'FTR-CRT-02',
  FELLOW_TRAVELER_CREATE_FAILED = 'FTR-CRT-03',
  FELLOW_TRAVELER_UPDATE_SUCCESS = 'FTR-UPD-01',
  FELLOW_TRAVELER_UPDATE_BAD_REQUEST = 'FTR-UPD-02',
  FELLOW_TRAVELER_UPDATE_FAILED = 'FTR-UPD-03',
  FELLOW_TRAVELER_DELETE_SUCCESS = 'FTR-DEL-01',
  FELLOW_TRAVELER_DELETE_FAILED = 'FTR-DEL-02',

  ONBOARDING_COMPLETED = 'ONB-CMP-01',
  ONBOARDING_NOT_COMPLETED = 'ONB-NOT-01',
  ONBOARDING_TERMS_NOT_ACCEPTED = 'ONB-TER-01',
}

export type MessageTextId = Brand<string, 'messageId'>;

export const MESSAGE_TEXT_SCHEMA: z.ZodType<IMessageText> = z.object({
  id: z
    .uuid()
    .transform((s: string) => s as MessageTextId)
    .optional(),
  code: z.string().regex(/^[A-Z]{3,}-[A-Z]{3}-\d{2}$/, {
    message: 'Invalid message code format (expected: DOMAIN-ACT-00)',
  }),
  text: TEXT_SCHEMA,
});
export const MESSAGE_TEXTS_SCHEMA: z.ZodType<IMessageText[]> =
  z.array(MESSAGE_TEXT_SCHEMA);
export interface IMessageText {
  id?: MessageTextId;
  code: string;
  text: IText;
}

export const MESSAGE_SCHEMA: z.ZodType<IMessage> = z.object({
  code: z.enum(EMessageCode).optional(),
  type: z.enum(EMessageType),
  context: z.string().optional(),
  priority: z.number().optional(),
  params: z.record(z.string(), z.any()).optional(),
  dismissAfterMs: z.number().optional(),
  text: MESSAGE_TEXT_SCHEMA.optional(),
});

export interface IMessage {
  code?: EMessageCode; // Numeric code, stable reference
  type: EMessageType; // Controls UI rendering
  priority?: number;
  params?: Record<string, any>; // Interpolation variables
  dismissAfterMs?: number; // For toasts and auto-hiding
  text?: IMessageText;
}

export interface IMessageWithText extends IMessage {
  code: EMessageCode;
  context: string;
}

export const TEMPLATE_CODES: Partial<Record<EMessageCode, string[]>> = {
  [EMessageCode.ENTITY_CREATE_VALIDATION_ERROR]: ['text', 'row', 'error'],
  [EMessageCode.ENTITY_CREATE_VALIDATION_SUCCESS]: ['entity'],
  [EMessageCode.ENTITY_DELETE_BAD_REQUEST]: ['entity'],
  [EMessageCode.ENTITY_DELETE_SUCCESS]: ['entity'],
  [EMessageCode.ENTITY_DELETE_REPOSITORY_ERROR]: ['entity'],
  [EMessageCode.ENTITY_DELETE_FILE_ERROR]: ['entity'],
  [EMessageCode.ENTITY_DOWNLOAD_ERROR]: ['entity'],
  [EMessageCode.ENTITY_FINDALL_REPOSITORY_ERROR]: ['entity'],
  [EMessageCode.ENTITY_FINDALL_EMPTY]: ['entity'],
  [EMessageCode.ENTITY_FINDONE_REPOSITORY_ERROR]: ['entity'],
  [EMessageCode.ENTITY_FILE_ERROR]: ['entity'],
  [EMessageCode.ENTITY_EXPORT_SUCCESS]: ['entity'],
  [EMessageCode.ENTITY_SAVED_BAD_REQUEST]: ['entity'],
  [EMessageCode.ENTITY_SAVED_REPOSITORY_ERROR]: ['entity'],
  [EMessageCode.ENTITY_SAVED_SUCCESS]: ['entity'],
  [EMessageCode.ENTITY_UPLOAD_BAD_REQUEST]: ['entity'],
  [EMessageCode.ENTITY_UPLOAD_REPOSITORY_ERROR]: ['entity'],
  [EMessageCode.ENTITY_UPLOAD_SUCCESS]: ['entity'],
  [EMessageCode.TICKET_CANNOT_BE_ADDED]: ['maxAmount'],
};
export const isTemplateCode: (code: EMessageCode) => boolean = (
  code: EMessageCode
): boolean => {
  return !!TEMPLATE_CODES[code];
};
export const getTemplateCode: (code: EMessageCode) => string[] = (
  code: EMessageCode
): string[] => {
  return TEMPLATE_CODES[code] ? TEMPLATE_CODES[code] : [];
};

export const DEFAULT_MESSAGE_TEXTS: IMessageText[] = [
  {
    id: '00aef450-ebfa-4781-82a8-7528663cc897' as MessageTextId,
    code: EMessageCode.ENTITY_CREATE_VALIDATION_SUCCESS,
    text: {
      id: '4bc8a2d9-dcba-4768-891a-e28adb957548' as TextId,
      values: [
        {
          id: 'efbfbc61-9e88-4dc4-a815-8a251a9bdc53' as TextLanguageValueId,
          value: 'Validierung erfolgreich.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'd4ecf3c5-67c8-492d-9ed5-2dcc54a4ddcd' as MessageTextId,
    code: EMessageCode.ENTITY_CREATE_VALIDATION_ERROR,
    text: {
      id: 'be8c1f5f-801c-482c-8357-44bd5f677c72' as TextId,
      values: [
        {
          id: '503b2568-393d-4b20-b40e-ba9ee1117010' as TextLanguageValueId,
          value:
            'In Zeile {{row}} bei Text "{{text}}" ist ein Fehler. Die Datei konnte nicht eingelesen werden.\n',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '1c58a0c2-d1f4-46b2-b8ad-ecfe1fce1bdb' as MessageTextId,
    code: EMessageCode.ENTITY_DOWNLOAD_ERROR,
    text: {
      id: 'd39e20e6-0111-4d04-8ff7-e63c717bed4a' as TextId,
      values: [
        {
          id: 'aaf0640b-46ed-4372-9bac-4ab21d9bb8ba' as TextLanguageValueId,
          value: 'Bei dem Herunterladen der Daten ist ein Fehler aufgetreten.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'c9968048-ed34-49dc-aabf-b0c01cf6caaa' as MessageTextId,
    code: EMessageCode.USER_VALIDATION_SUCCESS,
    text: {
      id: '40cb9c7f-a4fa-459a-85b2-a41f83069335' as TextId,
      values: [
        {
          id: '1dd8a3e3-824e-4262-9f14-b238314ccf3f' as TextLanguageValueId,
          value: 'Die Nutzerdaten wurden erfolgreich aktualisiert.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '21d01249-b909-498e-af39-6285a6a09b5c' as MessageTextId,
    code: EMessageCode.USER_UPDATE_FAILED,
    text: {
      id: '4c9f1258-7fcd-4bf4-b93e-4e644899317b' as TextId,
      values: [
        {
          id: 'b3b1857e-7bb7-4523-a53c-a2a920f1b870' as TextLanguageValueId,
          value: 'Die Nutzerdaten konnten nicht aktualisiert werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '47d0ab08-6401-403e-bc4d-9883877c262a' as MessageTextId,
    code: EMessageCode.USER_VALIDATION_ERROR,
    text: {
      id: '47d0ab08-6401-403e-bc4d-9883877c262a' as TextId,
      values: [
        {
          id: '47d0ab08-6401-403e-bc4d-9883877c262a' as TextLanguageValueId,
          value: 'Aktivierung fehlgeschlagen, Token inkorrekt oder abgelaufen',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'b50e57df-3532-4b99-8537-0d71ca1b9f68' as MessageTextId,
    code: EMessageCode.ORDER_FETCH_FAILED,
    text: {
      id: '9a096cdf-2b25-4c70-8f4f-a63a6ade9858' as TextId,
      values: [
        {
          id: 'da9d1a91-437a-48fb-8c4a-7cca5738ffad' as TextLanguageValueId,
          value: 'Bestellungen nicht gefunden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'f199fd37-13d0-4041-8da3-eaced9319269' as MessageTextId,
    code: EMessageCode.NOTIFY_MAIL_SEND_ERROR,
    text: {
      id: '96b970c0-b8f6-4c81-9a0a-9d684f515743' as TextId,
      values: [
        {
          id: '605f7604-1c9f-4796-a70c-44a7d128f82c' as TextLanguageValueId,
          value: 'E-Mail konnte nicht versandt werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '336545f3-927a-4218-bc8c-1a80ad766324' as MessageTextId,
    code: EMessageCode.NOTIFY_MAIL_SEND_SUCCESS,
    text: {
      id: '514dc974-5c2d-4a76-8994-1321b9b2fc4b' as TextId,
      values: [
        {
          id: '260e2e07-194b-4c92-8aa9-e0ca51dac7d7' as TextLanguageValueId,
          value: 'E-Mail erfolgreich versendet.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'de0f2e05-fd7c-47c7-9f5c-4717e6bd7dcd' as MessageTextId,
    code: EMessageCode.TARIFF_FETCH_TIMEOUT,
    text: {
      id: '9095eb2b-64bd-4a71-81a5-193deee80c8d' as TextId,
      values: [
        {
          id: '5732bd5d-9f06-4093-9182-d3d6b55013d1' as TextLanguageValueId,
          value: 'Tarifservice antwortet nicht.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'e45e8c91-e6e5-44d2-96cb-6495213582d3' as MessageTextId,
    code: EMessageCode.TARIFF_FETCH_FAILED,
    text: {
      id: 'b743fcc9-dcd1-448c-8228-9a0ec5fa5379' as TextId,
      values: [
        {
          id: '919c9643-0131-4650-89cc-a767a6e284da' as TextLanguageValueId,
          value: 'Tarif nicht gefunden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'f45ff363-8f29-497f-a66b-c5acb37b03b4' as MessageTextId,
    code: EMessageCode.TICKETS_CREATE_DOCUMENTS_SUCCESS,
    text: {
      id: '23ee5231-c7e9-458a-8197-0428b90d6907' as TextId,
      values: [
        {
          id: 'e14130e0-094b-4e5e-8fdf-cb5bb471ce51' as TextLanguageValueId,
          value: 'Dokument erzeugt!',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'dca4c454-c058-482a-8dc2-90149ea54570' as MessageTextId,
    code: EMessageCode.TICKETS_SEND_EMAILS_SUCCESS,
    text: {
      id: 'bc814694-fcae-4c87-b2fa-bfb6e32544a2' as TextId,
      values: [
        {
          id: '0a689069-e152-4bc8-940f-7878e6642024' as TextLanguageValueId,
          value: 'Ticket E-Mail versendet!',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '06d49106-c311-4f9c-a09b-348994b4115e' as MessageTextId,
    code: EMessageCode.TICKETS_CREATE_SECURITY_DETAIL_SUCCESS,
    text: {
      id: 'be942c5f-21fe-47d5-bf02-9ed26d010e9e' as TextId,
      values: [
        {
          id: 'aa74c682-4b1a-46b5-be8a-724e1e1ec7e7' as TextLanguageValueId,
          value: 'Sicherheitsmerkmale generiert!',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '9524734d-1022-428b-85dc-9f3e6ec4f3a9' as MessageTextId,
    code: EMessageCode.TICKETS_CREATE_ENTITLEMENT_SUCCESS,
    text: {
      id: '106c3cb1-10b5-4cd2-ad71-f594c5b3464c' as TextId,
      values: [
        {
          id: '9f6a77fa-267c-4212-bfba-be6f3654b1e6' as TextLanguageValueId,
          value: 'Berechtigungen erhalten!',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '79b34482-b526-4fd2-ab17-fbe0a891f9f5' as MessageTextId,
    code: EMessageCode.TICKETS_PAYMENT_STARTED,
    text: {
      id: '5e8de6d9-0b25-405f-97fa-2a003046af78' as TextId,
      values: [
        {
          id: '0143a28a-c2fe-4f07-88c2-b65d0c666c67' as TextLanguageValueId,
          value: 'Zahlungsprozess begonnen!',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'a3e54fe3-430e-4ae4-8260-3d2286f22eb6' as MessageTextId,
    code: EMessageCode.TICKETS_PAYMENT_SUCCESS,
    text: {
      id: '5514cafb-5a7d-4052-8f07-5eb13848cf07' as TextId,
      values: [
        {
          id: 'a01677b7-f7ee-4e5c-af0f-449e796691be' as TextLanguageValueId,
          value: 'Zahlung erfolgreich abgeschlossen!',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '541a4417-47df-4578-9dfc-fa1e9c4f3c7f' as MessageTextId,
    code: EMessageCode.TICKETS_PAYMENT_FAILED,
    text: {
      id: '66856d37-2cf7-4ba3-8865-74a5d26cceec' as TextId,
      values: [
        {
          id: '22e152ec-0afa-4e37-80d4-4a62b5148674' as TextLanguageValueId,
          value: 'Zahlung fehlgeschlagen.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '88904fa6-b420-468d-8884-f9a50f9c3282' as MessageTextId,
    code: EMessageCode.TICKETS_VALIDATION_FAILED,
    text: {
      id: '9d39f40e-cd3d-4cc3-b8cc-2783fe34db92' as TextId,
      values: [
        {
          id: '815a9cef-3637-4c4f-8269-e847d35b5a33' as TextLanguageValueId,
          value: 'Ticket Validierung fehlgeschlagen.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'f35e2e0d-ffcf-4ba1-99fa-55d7904a206a' as MessageTextId,
    code: EMessageCode.TICKETS_CREATE_ORDER_FAILED,
    text: {
      id: 'd70755cb-32b0-4d53-b2be-9da1a67ac61e' as TextId,
      values: [
        {
          id: '56ab9b85-577a-4e2c-ac28-25075ce74da6' as TextLanguageValueId,
          value: 'Bestellung konnte nicht erstellt werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '6a773577-4a39-4cd8-ab5b-796c894b5623' as MessageTextId,
    code: EMessageCode.TICKETS_CREATE_ORDER_SUCCESS,
    text: {
      id: 'c92c110e-fc30-49b5-80a8-d73cb411a9c5' as TextId,
      values: [
        {
          id: '7b70f827-d668-4c52-8836-29ef84bbb9d7' as TextLanguageValueId,
          value: 'Bestellung erhalten!',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'c6d47d7e-1703-4777-8c95-e27099b64807' as MessageTextId,
    code: EMessageCode.TICKETS_FETCH_FAILED,
    text: {
      id: '2d66cafe-222e-4573-a141-1e2dc9a5ef01' as TextId,
      values: [
        {
          id: '84c6cc73-6e81-443f-a429-7f789a892e96' as TextLanguageValueId,
          value: 'Direkt-Tickets konnten nicht geladen werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'a7edb8de-b3b9-454e-a024-073b8c8f91e0' as MessageTextId,
    code: EMessageCode.TICKETS_VALIDATION_SUCCESS,
    text: {
      id: 'b62f92d6-e145-4a05-b3a2-43375d04932b' as TextId,
      values: [
        {
          id: 'a7a317a9-6c82-4b85-be92-59db86d74516' as TextLanguageValueId,
          value: 'Ticket Validierung abgeschlossen!',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'a672af4f-1c18-4a1a-b741-614699e39a05' as MessageTextId,
    code: EMessageCode.TICKETS_GUEST_PAYMENT_FAILED,
    text: {
      id: '99fab7ac-b682-44bd-8c5b-fc990747462d' as TextId,
      values: [
        {
          id: 'ee6f92da-9036-4ab1-8d09-509ffe1dedb4' as TextLanguageValueId,
          value: 'Gastkauf fehlgeschlagen.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'ae6fce71-6646-4592-93b0-adf2544a731d' as MessageTextId,
    code: EMessageCode.CONFIGURATION_PAYMENT_ERROR,
    text: {
      id: '1d0a4b66-9c91-45b9-9f1e-caf48cfe27de' as TextId,
      values: [
        {
          id: '50900a38-16e8-4423-b2cf-aa86a521ba3d' as TextLanguageValueId,
          value: 'Zahlung fehlgeschlagen.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'ba42a392-1c37-4d6d-b6c8-9c5cf8a1453d' as MessageTextId,
    code: EMessageCode.TICKETS_GUEST_PAYMENT_SUCCESS,
    text: {
      id: '84b9d76d-d7cd-46c6-bba3-0f05b5df4348' as TextId,
      values: [
        {
          id: 'e118761e-384d-4e2a-b911-518a726bb654' as TextLanguageValueId,
          value: 'Gastkauf erfolgreich abgeschlossen!',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '73f80206-f8ce-43ff-a3df-ab8f55835b71' as MessageTextId,
    code: EMessageCode.CONFIGURATION_PAYMENT_GUEST,
    text: {
      id: '40508649-4929-412c-b149-ce05197e3d58' as TextId,
      values: [
        {
          id: 'a3fc5b2b-d094-4c8d-98f7-f6952d206c29' as TextLanguageValueId,
          value: 'Gastkaufprozess begonnen!',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'ec5e78a4-dedd-4614-9452-4f34e083d791' as MessageTextId,
    code: EMessageCode.CONFIGURATION_FIND_ERROR,
    text: {
      id: '03006369-32a0-41f8-92a2-f7a62feb5467' as TextId,
      values: [
        {
          id: 'a5fd17c0-b954-429b-8c1c-8f974f17468f' as TextLanguageValueId,
          value: 'Shopkonfiguration konnte nicht geladen werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '41dff0fa-1e90-47bd-9686-d97716491295' as MessageTextId,
    code: EMessageCode.USER_VALIDATION_NOT_ACTIVE,
    text: {
      id: 'ba3e9e14-5d5f-418e-9060-01f8698e637f' as TextId,
      values: [
        {
          id: '72766138-b57e-423b-b019-9592a066a554' as TextLanguageValueId,
          value: 'Login fehlgeschlagen: Nutzer ist inaktiv.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '13268810-9380-4c06-860f-1d06007f9ea3' as MessageTextId,
    code: EMessageCode.USER_UPDATE_BAD_REQUEST,
    text: {
      id: '89b56da3-30d6-466a-b6ad-1c0f9d68aa6a' as TextId,
      values: [
        {
          id: 'e625d786-18b1-44d5-89bd-5c7dac217a64' as TextLanguageValueId,
          value: 'Userdaten konnten nicht angepasst werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '45210e82-ade5-432f-8272-4b82ecd9d596' as MessageTextId,
    code: EMessageCode.USER_PASSWORD_RESET_SUCCESS,
    text: {
      id: 'f4c6cb30-f00a-42e7-8aa3-fea528b3e840' as TextId,
      values: [
        {
          id: 'a2732c90-69af-4016-81bc-6b0de449d64a' as TextLanguageValueId,
          value: 'Passwort erfolgreich zurückgesetzt.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'dca71f63-8903-4371-a980-443b59cfd045' as MessageTextId,
    code: EMessageCode.USER_PASSWORD_RESET_FAILED,
    text: {
      id: '1dea37cf-88d6-4667-989b-5502880d492a' as TextId,
      values: [
        {
          id: 'b000b874-cac2-4337-9fc6-897e5926c25e' as TextLanguageValueId,
          value:
            'Es ist ein Fehler aufgetreten, das Passwort konnte nicht zurückgesetzt werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '1809aa1b-fc6b-4c0d-9ca1-838463a557d9' as MessageTextId,
    code: EMessageCode.USER_UPDATE_SUCCESS,
    text: {
      id: '4f7c37c8-add0-4311-a37f-0ddf87223d7a' as TextId,
      values: [
        {
          id: '08d8fd16-354e-440b-8008-8f94c97befe0' as TextLanguageValueId,
          value: 'Daten gespeichert! ',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'bc94cee3-923b-4751-bbc6-cb3ad1da3937' as MessageTextId,
    code: EMessageCode.LOGOUT_SUCCESS,
    text: {
      id: '61b5e108-6bb1-46f2-a755-6760c73278b2' as TextId,
      values: [
        {
          id: '737e9de3-838b-4652-9dbd-30f6a1d1868d' as TextLanguageValueId,
          value: 'Logout erfolgreich!',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '03e67c86-c4fa-4c27-8eac-edbefa70624f' as MessageTextId,
    code: EMessageCode.LOGIN_FAILED,
    text: {
      id: '768c57df-8144-45c2-a259-b14fd1b9785d' as TextId,
      values: [
        {
          id: '7fd88b11-4f7f-433b-944a-00ebffdd11c3' as TextLanguageValueId,
          value: 'Login fehlgeschlagen!',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'cc4ae8e1-f794-4ebb-995d-329535b806b1' as MessageTextId,
    code: EMessageCode.LOGIN_SUCCESS,
    text: {
      id: 'e1c7555b-acf9-417c-ae6c-7e65ccbed7f8' as TextId,
      values: [
        {
          id: 'abc57f3f-19d6-4134-999e-7621a4b97f61' as TextLanguageValueId,
          value: 'Login erfolgreich!',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '7a440ab1-4401-4251-870d-f116ac6958ce' as MessageTextId,
    code: EMessageCode.ENTITY_EXPORT_SUCCESS,
    text: {
      id: '7c01b322-4b20-43dc-8287-1748b00830e6' as TextId,
      values: [
        {
          id: '82981ad2-4524-41cb-8f62-6e4e0c65d371' as TextLanguageValueId,
          value: '{{entity}} Export erfolgreich.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '285a36ce-3eeb-4e1e-bfdf-74de03e96f2b' as MessageTextId,
    code: EMessageCode.ENTITY_FILE_ERROR,
    text: {
      id: 'a886afbc-1353-4c83-9531-12b7e6da87e3' as TextId,
      values: [
        {
          id: '37d67f91-1c02-437c-8f32-ab70c5dc8040' as TextLanguageValueId,
          value: '{{entity}}  Dateifehler.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'b2979712-2190-453c-a5dc-547050f02c7f' as MessageTextId,
    code: EMessageCode.ENTITY_UPLOAD_REPOSITORY_ERROR,
    text: {
      id: '126666dc-33aa-4d8d-9d1c-0949ef21cccd' as TextId,
      values: [
        {
          id: 'da285e36-1fa2-4264-9ada-bf4f0a1f0e17' as TextLanguageValueId,
          value: '{{entity}} Upload fehlgeschlagen.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '9437f1ad-4f31-41a3-aa81-03f0c29f06cf' as MessageTextId,
    code: EMessageCode.ENTITY_UPLOAD_BAD_REQUEST,
    text: {
      id: 'c3d74f86-a952-42fc-b8a8-b8dff784f8b1' as TextId,
      values: [
        {
          id: '924a10a7-f48c-4696-893e-e71ae41a71fb' as TextLanguageValueId,
          value: '{{entity}} Upload nicht möglich.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '15636f93-abfe-4d27-86b0-9dc59357deab' as MessageTextId,
    code: EMessageCode.ENTITY_UPLOAD_SUCCESS,
    text: {
      id: 'f3def2a2-9090-4056-bd83-d549ac49621e' as TextId,
      values: [
        {
          id: '32b517cc-1f09-4cf5-929a-1f9e3e0098de' as TextLanguageValueId,
          value: '{{entity}} Upload erfolgreich.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '1d5176d4-dd51-44bd-989a-d066ca9e5fcb' as MessageTextId,
    code: EMessageCode.ENTITY_DELETE_BAD_REQUEST,
    text: {
      id: '5ca7e5d2-07ab-4c60-b6bc-8a7e93f42ee3' as TextId,
      values: [
        {
          id: '85c86094-76b2-4b9b-aaf6-d6f36b3978ee' as TextLanguageValueId,
          value: '{{entity}} Löschung abgebrochen.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '1c215892-795d-45f8-871d-f6a9601a6940' as MessageTextId,
    code: EMessageCode.ENTITY_DELETE_FILE_ERROR,
    text: {
      id: '4c92a7de-6486-4e2b-b535-35441f6a3448' as TextId,
      values: [
        {
          id: '4ea87d23-dd70-4302-b2f1-e1c743245779' as TextLanguageValueId,
          value: '{{entity}} Datei konnte nicht gelöscht werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '9287536d-76dd-4df1-a299-9943017351be' as MessageTextId,
    code: EMessageCode.ENTITY_DELETE_REPOSITORY_ERROR,
    text: {
      id: 'a00df49a-c741-4058-9095-039ef0f4280c' as TextId,
      values: [
        {
          id: 'cdda9e89-c99e-4d28-a2b1-eb3cdb4b7d15' as TextLanguageValueId,
          value: '{{entity}} konnte nicht gelöscht werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'd445fb11-0aeb-4fef-925e-07d5219b9b80' as MessageTextId,
    code: EMessageCode.ENTITY_DELETE_SUCCESS,
    text: {
      id: '18c07a4d-d0a4-4998-8b8c-6f4f2fe45d68' as TextId,
      values: [
        {
          id: 'f9e90721-3e2d-46ae-93bc-90a84ef4fea6' as TextLanguageValueId,
          value: '{{entity}} erfolgreich gelöscht.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '5e5b5dff-786a-4cfc-8884-bb5efe30774c' as MessageTextId,
    code: EMessageCode.ENTITY_FINDALL_EMPTY,
    text: {
      id: '8ca859c1-0ae4-406a-817f-8e6307e6c95a' as TextId,
      values: [
        {
          id: '7ffa6bfe-9f3d-40ed-a0fc-393fc16c3318' as TextLanguageValueId,
          value: 'Keine {{entity}} vorhanden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'da46c7a5-0a1b-4c42-bf7d-fe54573e7042' as MessageTextId,
    code: EMessageCode.ENTITY_FINDALL_REPOSITORY_ERROR,
    text: {
      id: '1258083b-8828-4b49-abb6-568ba5971df0' as TextId,
      values: [
        {
          id: '1eadf274-bd22-4dfa-aab4-fbf627cbd4ee' as TextLanguageValueId,
          value: '{{entity}} konnten nicht geladen werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '1d2069b1-5a74-45f5-8f15-cca48919c0b0' as MessageTextId,
    code: EMessageCode.ENTITY_FINDONE_REPOSITORY_ERROR,
    text: {
      id: '6a8823ee-3675-49de-a827-ab2cd860e534' as TextId,
      values: [
        {
          id: '6100b8d7-4b2d-4478-a17c-2f5501eae743' as TextLanguageValueId,
          value: '{{entity}} konnte nicht gefunden werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '162f8d6e-3ae7-4a53-9bdc-14b6a2e796ac' as MessageTextId,
    code: EMessageCode.ENTITY_SAVED_REPOSITORY_ERROR,
    text: {
      id: '929f6f2b-8777-443c-86ce-516c89348d3c' as TextId,
      values: [
        {
          id: '56400cd2-c353-4d19-9f5d-e04f6a9d4179' as TextLanguageValueId,
          value: '{{entity}} speichern fehlgeschlagen.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '74751acf-d029-4c37-9482-f531a78dae96' as MessageTextId,
    code: EMessageCode.ENTITY_SAVED_BAD_REQUEST,
    text: {
      id: '9356ad31-0618-44ed-9cff-853d7953388f' as TextId,
      values: [
        {
          id: '3340e0cf-ccdc-4d67-a782-736603366714' as TextLanguageValueId,
          value: '{{entity}} kann gespeichert werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '45cb1dfa-e268-407f-8b9f-93511f52b222' as MessageTextId,
    code: EMessageCode.ENTITY_SAVED_SUCCESS,
    text: {
      id: '8268c0d9-8b87-4a2f-a033-b35839c34482' as TextId,
      values: [
        {
          id: 'eca6f7d8-b045-41cd-a7f8-aad6e5ee4e7d' as TextLanguageValueId,
          value: '{{entity}} erfolgreich gespeichert.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '2a65baac-8d1f-49ec-8913-998d4c18a29d' as MessageTextId,
    code: EMessageCode.ADDRESS_VALIDATION_ERROR,
    text: {
      id: 'd9ea1e54-54f4-4682-a6b3-509454df6df2' as TextId,
      values: [
        {
          id: 'c9eb12a2-ff33-44ca-bbcd-5de8d80f3196' as TextLanguageValueId,
          value: 'Adressvalidierung fehlgeschlagen.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '266b2bbe-fca3-4203-ae0a-8d3d1c605640' as MessageTextId,
    code: EMessageCode.HOUSE_NUMBERS_FETCH_REQUEST_ERROR,
    text: {
      id: '7ae833b8-a5eb-4bac-ada7-dc4831bac29c' as TextId,
      values: [
        {
          id: '97a04d39-1ceb-4dfc-b3bb-d8fa86a80f0b' as TextLanguageValueId,
          value: 'Hausnummern laden fehlgeschlagen.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '96cc30d3-085a-4710-881f-538d5ad5f827' as MessageTextId,
    code: EMessageCode.HOUSE_NUMBERS_FETCH_ERROR,
    text: {
      id: 'd41784d9-c070-4638-9f28-c9ecf2c2bbf9' as TextId,
      values: [
        {
          id: '683c5901-9b4b-4aef-9c06-78bfd0098d0f' as TextLanguageValueId,
          value: 'Hausnummern konnten nicht geladen werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'b2f730dd-80ea-490f-b365-c89baa6afbc7' as MessageTextId,
    code: EMessageCode.STREETS_FETCH_REQUEST_ERROR,
    text: {
      id: 'e33865bb-d1c4-41c7-a8ba-05f48b5df2df' as TextId,
      values: [
        {
          id: '41f1f10a-1ec4-4776-b04a-6c0bfd6be559' as TextLanguageValueId,
          value: 'Laden der Straßen nicht möglich.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'b04aeb42-2fb3-450e-ae9c-c59813f0cdfa' as MessageTextId,
    code: EMessageCode.STREETS_FETCH_ERROR,
    text: {
      id: '1efca83e-441a-48bb-9b60-579b39882105' as TextId,
      values: [
        {
          id: 'dd968f24-ba16-407a-8015-e0ace41e89b7' as TextLanguageValueId,
          value: 'Straßen konnten nicht geladen werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '5d36bc5f-90df-4808-93eb-78f8dbc41a03' as MessageTextId,
    code: EMessageCode.CITIES_FETCH_REQUEST_ERROR,
    text: {
      id: 'c87cf694-adb4-42c0-8772-62e4e7f73366' as TextId,
      values: [
        {
          id: 'fc60ea1d-a04f-401e-b4f2-a655ad1ab950' as TextLanguageValueId,
          value: 'Laden von Städten nicht möglich.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'f7d338e4-ba4a-4d03-9d74-dc167ee9da77' as MessageTextId,
    code: EMessageCode.CITIES_FETCH_ERROR,
    text: {
      id: '9fff856e-8407-4b9a-9d96-0aa3cd52210d' as TextId,
      values: [
        {
          id: 'ad9f0d13-69d4-447f-bb7d-43aaed19fcd8' as TextLanguageValueId,
          value: 'Städte konnten nicht geladen werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'ab10273b-5278-4493-b256-3da0a4c0c586' as MessageTextId,
    code: EMessageCode.COUNTRIES_FETCH_ERROR,
    text: {
      id: '3f3e9069-52b9-4d57-bbe2-70a285dd2e7e' as TextId,
      values: [
        {
          id: 'add3b454-7cbe-4a5d-a5f9-f908be9b108c' as TextLanguageValueId,
          value: 'Länder konnten nicht geladen werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '200a2ca5-1a28-418c-bf3d-b25e3450990d' as MessageTextId,
    code: EMessageCode.TOKEN_VALIDATION_SUCCESS,
    text: {
      id: '5bea592a-5b3c-4a36-8c93-84abbdf4f09d' as TextId,
      values: [
        {
          id: '876ad86a-7656-45bf-9f2f-7ab3fca718bd' as TextLanguageValueId,
          value: 'Token gültig.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '3578f34f-8873-46e1-a504-2e675943a6b2' as MessageTextId,
    code: EMessageCode.TOKEN_VALIDATION_FAILED,
    text: {
      id: 'f5a0cbc8-2d66-440d-8bb8-341542421417' as TextId,
      values: [
        {
          id: '11a1f1e4-8d24-4562-b0ab-1ddbbf447d4d' as TextLanguageValueId,
          value: 'Token ungültig.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'a1a26634-f2c7-4647-87fc-bce855d0888c' as MessageTextId,
    code: EMessageCode.TOKEN_CREATE_AND_MAIL_SENT_SUCCESS,
    text: {
      id: '10b3f747-cdb5-40a5-9717-e0ff44bed466' as TextId,
      values: [
        {
          id: '30df1394-39b0-4176-9084-93237dd61356' as TextLanguageValueId,
          value: 'Token erfolgreicht erstellt und Mail versandt.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '04cb26a5-df2a-45fa-91e4-6ff90d8a7933' as MessageTextId,
    code: EMessageCode.TOKEN_CREATE_AND_MAIL_SENT_FAILED,
    text: {
      id: 'fc39d5c9-714a-4a5c-956d-9838a75629c3' as TextId,
      values: [
        {
          id: '4e565a46-fca1-49ab-bb01-028b566a4730' as TextLanguageValueId,
          value: 'Fehler beim Erstellen und Versand des Tokens.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '8ddcfd66-3d84-405a-8596-3b25753769f2' as MessageTextId,
    code: EMessageCode.PAYMENT_METHOD_DELETE_SUCCESS,
    text: {
      id: '901fc56c-6d9c-44c9-ad06-e19ea43faf43' as TextId,
      values: [
        {
          id: 'be6d238d-294a-447f-ba8a-ee081db4d82f' as TextLanguageValueId,
          value: 'Zahlungsart erfolgreich gelöscht ',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },

  {
    id: '86ad4c6e-635c-420e-b08a-3a849d02cd01' as MessageTextId,
    code: EMessageCode.TICKET_CANNOT_BE_ADDED,
    text: {
      id: '88f5201c-4733-46db-a223-b300395c0777' as TextId,
      values: [
        {
          id: '6b90a4cf-afc8-4e03-8e38-c48b9a04b2ee' as TextLanguageValueId,
          value:
            'Ticket kann nicht hinzugefügt werden. Maximal {{maxAmount}} Tickets zulässig.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '157b0153-8e0a-4f4a-952d-241e0136e82f' as MessageTextId,
    code: EMessageCode.FELLOW_TRAVELERS_FIND_ALL_SUCCESS,
    text: {
      id: '75a3579a-721f-40e4-9274-73857a5a89b1' as TextId,
      values: [
        {
          id: '7df6820a-2d64-4f26-ab76-36daa5bf381c' as TextLanguageValueId,
          value: 'Mitreisende wurden erfolgreich geladen.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'fa911b83-44de-4447-8a01-63fbc9706134' as MessageTextId,
    code: EMessageCode.FELLOW_TRAVELERS_FIND_ALL_FAILED,
    text: {
      id: '691b0fc8-98e1-4a91-96e8-22ff6bcf9bae' as TextId,
      values: [
        {
          id: '97911372-f939-46b4-aa2b-3ae93f35c5e0' as TextLanguageValueId,
          value: 'Mitreisende konnten nicht geladen werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '07bf2eb9-6a2a-44df-a35b-eb79f46af4fc' as MessageTextId,
    code: EMessageCode.FELLOW_TRAVELER_FIND_ONE_SUCCESS,
    text: {
      id: '40dd6fb4-908e-4453-b07d-2179918ced0d' as TextId,
      values: [
        {
          id: '45970238-976c-4f30-a195-235b810717a3' as TextLanguageValueId,
          value: 'Mitreisende Person wurde erfolgreich geladen.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '55651416-5122-4b86-9dc4-076169cbccee' as MessageTextId,
    code: EMessageCode.FELLOW_TRAVELER_FIND_ONE_FAILED,
    text: {
      id: 'ebf6f50d-f9d2-4fbb-b61a-60d7d6e97a3f' as TextId,
      values: [
        {
          id: '527f161a-b41d-41b6-b4f9-01a695123bc2' as TextLanguageValueId,
          value: 'Mitreisende Person konnte nicht geladen werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'b0f9dd73-f749-4a0c-b378-5b3849a0c0f9' as MessageTextId,
    code: EMessageCode.FELLOW_TRAVELER_CREATE_SUCCESS,
    text: {
      id: 'c62500b8-51c3-4833-b15e-f4fc0af060ba' as TextId,
      values: [
        {
          id: 'f7e96be5-66d5-4a91-bb0e-aaee7599d111' as TextLanguageValueId,
          value: 'Mitreisende Person wurde erfolgreich erstellt.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '73a78091-8512-4ca8-9e94-84349872391f' as MessageTextId,
    code: EMessageCode.FELLOW_TRAVELER_CREATE_BAD_REQUEST,
    text: {
      id: 'e8b36ee7-15fe-4879-a3c0-390d76d6146e' as TextId,
      values: [
        {
          id: 'f5d28f37-b999-4720-ba20-5f25f31c0c15' as TextLanguageValueId,
          value: 'Ungültige Daten für die mitreisende Person.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '01fc4aa3-6bf7-481d-a51c-cade941111e1' as MessageTextId,
    code: EMessageCode.FELLOW_TRAVELER_CREATE_FAILED,
    text: {
      id: '2517181d-2fe1-4e18-bc35-472fd68f197a' as TextId,
      values: [
        {
          id: 'ce728372-b9fa-436e-a48b-c97a4540428d' as TextLanguageValueId,
          value: 'Mitreisende Person konnte nicht erstellt werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '364b4753-2710-4dba-9fe6-45abbbc24a4f' as MessageTextId,
    code: EMessageCode.FELLOW_TRAVELER_UPDATE_SUCCESS,
    text: {
      id: 'b350ce0f-4cf3-40b8-9d87-156aef24c731' as TextId,
      values: [
        {
          id: 'b413c1af-e9a8-4221-92ea-6ace5f1c1bf6' as TextLanguageValueId,
          value: 'Mitreisende Person wurde erfolgreich aktualisiert.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '810daf7a-08ef-405a-b0cb-bab61dd5040d' as MessageTextId,
    code: EMessageCode.FELLOW_TRAVELER_UPDATE_BAD_REQUEST,
    text: {
      id: '467104bc-6552-4a45-8e8a-07ca7a2bc075' as TextId,
      values: [
        {
          id: 'e3824dbc-4fcc-4f54-bd43-74eddd76b45f' as TextLanguageValueId,
          value: 'Ungültige Daten für die mitreisende Person.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: '521fd136-1534-4d7d-8feb-fc2afe347026' as MessageTextId,
    code: EMessageCode.FELLOW_TRAVELER_UPDATE_FAILED,
    text: {
      id: 'bf155339-d5e9-47f7-841e-cc8297c4716d' as TextId,
      values: [
        {
          id: 'efb9e0d7-88a1-44b2-9a87-06b18414e268' as TextLanguageValueId,
          value: 'Mitreisende Person konnte nicht aktualisiert werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'a5b2d4d4-67eb-410b-a59a-c4e1973541ad' as MessageTextId,
    code: EMessageCode.FELLOW_TRAVELER_DELETE_SUCCESS,
    text: {
      id: 'f9a6d3fb-c244-4c58-be95-d585d3cfe74f' as TextId,
      values: [
        {
          id: 'c941ce2a-db44-4ef0-bad2-aa7cc687ee73' as TextLanguageValueId,
          value: 'Mitreisende Person wurde erfolgreich gelöscht.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
  {
    id: 'f1009804-a39b-4db8-9c27-8ee7f600bab9' as MessageTextId,
    code: EMessageCode.FELLOW_TRAVELER_DELETE_FAILED,
    text: {
      id: '84da45ce-1daa-4627-a7ed-0fa3a70bd465' as TextId,
      values: [
        {
          id: '4a24952c-91d1-4cf5-83e3-2fa82c8aab9a' as TextLanguageValueId,
          value: 'Mitreisende Person konnte nicht gelöscht werden.',
          languagePrefix: 'DE' as LanguagePrefix,
        },
      ],
    },
  },
];
